import type {
  StringLocation,
  StringLocationIndex,
} from "../../scripts/string-locations-build-core"

let cached: StringLocationIndex | null = null

/**
 * Lazily import the committed crawl index. Dynamic import keeps it an edit-only
 * chunk — it never ships in the public bundle (mirrors loadMessageIndex()).
 */
export async function loadStringLocations(): Promise<StringLocationIndex> {
  if (cached) return cached
  const mod = await import("../../i18n/string-locations.json")
  cached = mod.default as StringLocationIndex
  return cached
}

/** Pure lookup: the location for a key, or null when the crawl never saw it. */
export function locationFor(
  index: StringLocationIndex,
  key: string
): StringLocation | null {
  return index.byKey[key] ?? null
}
